module.exports = __webpack_public_path__ + "img/ico_biaoqianshuijing.80b94462.png";